// ФАЙЛ: store.ts
// НАЗНАЧЕНИЕ: Runtime-хранилище словарей переводов плагинов overlay (i18n).
//
// Словари приходят с бэкенда в register_plugin (i18n) и обновляются сообщением
// update_i18n при смене языка стримера. Хранилище keyed by pluginType, чтобы
// каждый эффект-плагин резолвил строки независимо. Обновление словаря triggers
// re-render активных эффектов через подписку zustand — БЕЗ пересоздания
// компонентов и повторной верификации плагина.

import { create } from 'zustand'

/** Плоский словарь переводов одного плагина: ключ → строка. */
export type PluginDict = Record<string, string>

interface PluginI18nEntry {
  locale: string
  dict: PluginDict
}

interface PluginI18nState {
  /** Словари переводов по pluginType. */
  entries: Record<string, PluginI18nEntry>
  /** Устанавливает/заменяет словарь плагина (register_plugin / update_i18n). */
  setDict: (pluginType: string, locale: string, dict: PluginDict) => void
}

export const usePluginI18nStore = create<PluginI18nState>((set) => ({
  entries: {},
  setDict: (pluginType, locale, dict) =>
    set((state) => ({
      entries: { ...state.entries, [pluginType]: { locale, dict } },
    })),
}))
